import { axios } from '@/utils/request'

const api = {
  Pre: '/merchant.php/Member/pre',
  List: '/merchant.php/Member/getList',
  Detail: '/merchant.php/Member/detail'
}

// 预加载
export function getUserPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getUserList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function getUserDetail (parameter) {
  return axios({
    url: api.Detail,
    method: 'get',
    params: {
      uid: parameter
    }
  })
}
